module.exports = __webpack_public_path__ + "img/pro_ten_7.811adc4e.jpg";